import type {
  ClientRequest,
  ClientResponse,
  ContactRequest,
} from 'src/api/ProactApiClient';
import {COUNTRY_OPTIONS} from 'src/shared/constants/geoOptions';
import type {IFormFieldV2} from 'src/types/FormV2';

export {COUNTRY_OPTIONS};

export const ClientDocumentTitle = 'Clients';

export const ClientFormMeta: IFormFieldV2[] = [
  {
    name: 'name',
    label: 'Name',
    type: 'text',
    required: true,
    validation: {maxLength: 255},
  },
  {
    label: 'Address',
    name: 'heading1',
    type: 'heading',
  },
  {
    name: 'address',
    label: 'Address',
    type: 'text',
    required: false,
    validation: {maxLength: 255},
    size: 'md',
  },
  {
    name: 'city',
    label: 'City',
    type: 'text',
    required: false,
    validation: {maxLength: 100},
    size: 'md',
  },
  {
    name: 'state',
    label: 'State',
    type: 'text',
    required: false,
    validation: {maxLength: 100},
    size: 'sm',
  },
  {
    name: 'country',
    label: 'Country',
    type: 'select',
    options: COUNTRY_OPTIONS,
    required: false,
    size: 'sm',
  },
  {
    name: 'postalCode',
    label: 'Postal Code',
    type: 'text',
    required: false,
    validation: {maxLength: 20},
    size: 'sm',
  },
];

// Newtonsoft sends explicit `null` for absent nested values where the TS
// types say `undefined` — normalize at this response -> request boundary.
export const MapClientResponseToClientRequest = (
  data: ClientResponse
): ClientRequest => {
  return {
    id: data.id,
    name: data.name,
    address: data.address ?? undefined,
    city: data.city ?? undefined,
    state: data.state ?? undefined,
    country: data.country ?? undefined,
    postalCode: data.postalCode ?? undefined,
    contacts: (data.contacts ?? []).map(
      (contact): ContactRequest => ({
        id: contact.id,
        name: contact.name ?? undefined,
        title: contact.title ?? undefined,
        email: contact.email ?? undefined,
        phone: contact.phone ?? undefined,
      })
    ),
  };
};
